export const getBusinessRoutes = ({ urlPrefix = "" }) => [
  {
    title: "Overview",
    route: urlPrefix,
    fields: [
      "title",
      "url",
      "website",
      "phone",
      "description",
      "cover",
      "logo",
    ],
  },
  {
    title: "Locations",
    route: urlPrefix + "/locations",
  },
  {
    title: "Contacts",
    route: urlPrefix + "/contacts",
  },
  {
    title: "About",
    route: urlPrefix + "/about",
  },
  {
    title: "User Access",
    route: urlPrefix + "/user-access",
  },
]
